<template>
  <div id="app">
    <router-view></router-view>
 
  </div>
</template>

<script>
export default {
  name: "App",
  components: {

  },
  data() {
    return {};
  }
};
</script>

<style>
#app {
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}
</style>

<style src="./instagram.css"></style>
<style src="./elements.css"></style>
